var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import Http from 'axios';
import Builder from '@app/store/builder';
import Navigation from '@app/store/modules/navigation';
import Router from '@app/router';
import RouterFunctions from '@app/router/functions';
/**
 * Enable/disable debug info in the browser developer console
 */
export var DEBUG_MODE = false;
/**
 * Store root state and type definitions
 */
var STATE = Builder.state({
    pageLoading: window.SSR ? false : true,
    pageData: {},
    locale: null,
    languages: window.LANGUAGES || [],
    routesLoaded: null,
});
/**
 * Store state getters
 */
var GETTERS = {
    activeLanguage: function () {
        return STATE.languages.find(function (language) { return language.is_current == true; }) || null;
    }
};
/**
 * Store state mutations
 */
var MUTATIONS = {
    setLocale: function (locale) {
        STATE.locale = locale;
    },
    setLoading: function (loading) {
        STATE.pageLoading = loading;
    },
    setPageData: function (path, data) {
        Vue.set(STATE.pageData, path, data);
    },
    setRoutesLoadedPromise: function (promise) {
        STATE.routesLoaded = promise;
    }
};
/**
 * Store actions
 */
var ACTIONS = {
    loadRoutesData: function () {
        return __awaiter(this, void 0, void 0, function () {
            var api, response, routes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        api = Http.get('/api/routes');
                        MUTATIONS.setRoutesLoadedPromise(new Promise(function (resolve) {
                            api.then(function () { return resolve(); });
                        }));
                        return [4 /*yield*/, api];
                    case 1:
                        response = _a.sent();
                        routes = response.data.map(function (uri) {
                            var route = RouterFunctions.makeRoute(uri);
                            // Write eager loaded route data to store
                            if (uri.uriable && uri.uriable.parent) {
                                MUTATIONS.setPageData(route.path, uri.uriable.parent);
                            }
                            return route;
                        }).filter(function (route) {
                            // Filter out already existing routes
                            return !RouterFunctions.routeExists(route.path);
                        });
                        Router.addRoutes(routes);
                        RouterFunctions.addFinalRoutes();
                        return [2 /*return*/, response];
                }
            });
        });
    },
    loadPageData: function (path) {
        return Http.get("/api".concat(path)).then(function (res) {
            MUTATIONS.setPageData(path, res.data);
            return res.data;
        }).catch(function (ex) {
            MUTATIONS.setLoading(false);
            if (ex.response.status === 301 || ex.response.status === 302) {
                MUTATIONS.setPageData(path, ex.response.data);
                return ex.response.data;
            }
        });
    }
};
var Store = Vue.observable({
    STATE: STATE,
    GETTERS: GETTERS,
    MUTATIONS: MUTATIONS,
    ACTIONS: ACTIONS,
    Navigation: Navigation,
    registerModule: function (name, module) {
        Vue.set(this, name, module);
    }
});
export default Store;
